import { SubjectData } from 'shell/models/person';
import { DateTime } from 'luxon';
import { AccordionMarriage as MarriageVM } from 'shell/view-models/accordion-marriage';
import { transformToChoiceDate } from 'shell/components/shared/choice-date/functions';

export const transformMarriage = (person: SubjectData): MarriageVM | undefined => {
  const birthChoiceDate = transformToChoiceDate(
    person.matrimonio?.coniuge?.senzaGiorno,
    person.matrimonio?.coniuge?.senzaGiornoMese
  );

  const eventChoiceDate = transformToChoiceDate(
    person.matrimonio?.datiMatrimonio?.senzaGiorno,
    person.matrimonio?.datiMatrimonio?.senzaGiornoMese
  );

  const isDigital = Boolean(person.matrimonio?.datiMatrimonio?.attoEventoANPR?.attoANSC);

  const originReturnData: MarriageVM | undefined = person.matrimonio
    ? {
        number: person.matrimonio?.ordineMatrimonio
          ? Number.parseInt(person.matrimonio?.ordineMatrimonio, 10)
          : 0,
        generality: person.matrimonio?.coniuge
          ? {
              fiscalCode: person.matrimonio?.coniuge?.codiceFiscale?.codFiscale || '',
              name: person.matrimonio?.coniuge?.nome || '',
              surname: person.matrimonio?.coniuge?.cognome || '',
              validityFiscalCodeId: person.matrimonio?.coniuge?.codiceFiscale?.validitaCF || '',
              aire: person.matrimonio?.coniuge?.soggettoAIRE,
              withoutName: person.matrimonio?.coniuge?.senzaNome === '1' ? true : false,
              withoutSurname: person.matrimonio?.coniuge?.senzaCognome === '1' ? true : false,
              validityFiscalCode: person.matrimonio?.coniuge?.codiceFiscale?.validitaCF,
              validityDateFiscalCode: person.matrimonio?.coniuge?.codiceFiscale
                ?.dataAttribuzioneValidita
                ? DateTime.fromISO(
                    person.matrimonio?.coniuge?.codiceFiscale?.dataAttribuzioneValidita
                  )
                : null,
              gender: person.matrimonio?.coniuge?.sesso || '',
              expatriationYear: person.matrimonio?.coniuge?.annoEspatrio || '',
              birthDate: person.matrimonio?.coniuge?.dataNascita
                ? DateTime.fromISO(person.matrimonio?.coniuge?.dataNascita)
                : null,
              // senza giorno mese, etc
              birthChoiceDate,
              // generality italian form
              isForeign: !person.matrimonio?.coniuge?.luogoNascita?.comune,
              italian: person.matrimonio?.coniuge?.luogoNascita?.comune
                ? {
                    location:
                      person.matrimonio?.coniuge?.luogoNascita?.comune?.descrizioneLocalita || '',
                    province:
                      person.matrimonio?.coniuge?.luogoNascita?.comune?.siglaProvinciaIstat || '',
                    // municipality: person.matrimonio?.coniuge?.luogoNascita?.comune?.nomeComune || '',
                    municipality: person.matrimonio?.coniuge?.luogoNascita?.comune
                      ? {
                          description:
                            person.matrimonio?.coniuge?.luogoNascita?.comune?.nomeComune || '',
                          province:
                            person.matrimonio?.coniuge?.luogoNascita?.comune?.siglaProvinciaIstat ||
                            '',
                          id: person.matrimonio?.coniuge?.luogoNascita?.comune?.codiceIstat || '',
                        }
                      : undefined,
                  }
                : undefined,
              // generality foreign form
              foreign: person.matrimonio?.coniuge?.luogoNascita?.localita
                ? {
                    state: {
                      id: person.matrimonio?.coniuge?.luogoNascita?.localita?.codiceStato || '',
                      value:
                        person.matrimonio?.coniuge?.luogoNascita?.localita?.descrizioneStato || '',
                      province:
                        person.matrimonio?.coniuge?.luogoNascita?.localita?.provinciaContea || '',
                    },
                    province:
                      person.matrimonio?.coniuge?.luogoNascita?.localita?.provinciaContea || '',
                    municipality: {
                      description:
                        person.matrimonio?.coniuge?.luogoNascita?.localita?.descrizioneLocalita ||
                        '',
                      province:
                        person.matrimonio?.coniuge?.luogoNascita?.localita?.provinciaContea || '',
                    },
                  }
                : undefined,
              // Other fields generality
              exceptionalBirthPlace:
                person.matrimonio?.coniuge?.luogoNascita?.luogoEccezionale || '',
              municipalityIdentifier:
                person.matrimonio?.coniuge?.idSchedaSoggettoComune?.idSchedaSoggetto || '',
              istatCode:
                person.matrimonio?.coniuge?.idSchedaSoggettoComune?.idSchedaSoggettoComuneIstat ||
                '',
              anprIdentifier: person.matrimonio?.coniuge?.idSchedaSoggettoANPR || '',
              note: person.matrimonio?.coniuge?.note || '',
            }
          : undefined,
        person: person.matrimonio?.coniuge
          ? {
              fiscalCode: person.matrimonio?.coniuge?.codiceFiscale?.codFiscale || '',
              name: person.matrimonio?.coniuge?.nome || '',
              surname: person.matrimonio?.coniuge?.cognome || '',
              withoutName: person.matrimonio?.coniuge?.senzaNome === '1' ? true : false,
              withoutSurname: person.matrimonio?.coniuge?.senzaCognome === '1' ? true : false,
            }
          : undefined,
        from: person.matrimonio?.cittadinanza?.dataValidita
          ? DateTime.fromISO(person.matrimonio?.cittadinanza?.dataValidita)
          : null,
        citizenshipCode: person.matrimonio?.cittadinanza?.codiceStato || '',
        // citizenship: person.matrimonio?.cittadinanza?.descrizioneStato || '',
        citizenship: person.matrimonio?.cittadinanza
          ? {
              id: person.matrimonio?.cittadinanza?.codiceStato || '',
              value: person.matrimonio?.cittadinanza?.descrizioneStato || '',
            }
          : undefined,
        note: person.matrimonio?.cittadinanza?.noteStato || '',
        italian: person.matrimonio?.datiMatrimonio?.luogoEvento?.comune
          ? {
              location:
                person.matrimonio?.datiMatrimonio?.luogoEvento?.comune?.descrizioneLocalita || '',
              // municipality: person.matrimonio?.datiMatrimonio?.luogoEvento?.comune?.nomeComune || '',
              municipality: {
                id: person.matrimonio?.datiMatrimonio?.luogoEvento?.comune?.codiceIstat || '',
                description:
                  person.matrimonio?.datiMatrimonio?.luogoEvento?.comune?.nomeComune || '',
                province:
                  person.matrimonio?.datiMatrimonio?.luogoEvento?.comune?.siglaProvinciaIstat || '',
              },
              province:
                person.matrimonio?.datiMatrimonio?.luogoEvento?.comune?.siglaProvinciaIstat || '',
            }
          : undefined,
        foreign: person.matrimonio?.datiMatrimonio?.luogoEvento?.localita
          ? {
              // municipality:
              //   person.matrimonio?.datiMatrimonio?.luogoEvento?.localita?.descrizioneLocalita || '',
              municipality: {
                description:
                  person.matrimonio?.datiMatrimonio?.luogoEvento?.localita?.descrizioneLocalita ||
                  '',
                province:
                  person.matrimonio?.datiMatrimonio?.luogoEvento?.localita?.provinciaContea || '',
              },
              province:
                person.matrimonio?.datiMatrimonio?.luogoEvento?.localita?.provinciaContea || '',
              state: {
                id: person.matrimonio?.datiMatrimonio?.luogoEvento?.localita?.codiceStato || '',
                value:
                  person.matrimonio?.datiMatrimonio?.luogoEvento?.localita?.descrizioneStato || '',
                province: person.matrimonio?.coniuge?.luogoNascita?.localita?.provinciaContea || '',
              },
            }
          : undefined,
        isForeign: !!person.matrimonio?.datiMatrimonio?.luogoEvento?.localita,
        eventDate: person.matrimonio?.datiMatrimonio?.dataEvento
          ? DateTime.fromISO(person.matrimonio?.datiMatrimonio?.dataEvento)
          : null,
        eventChoiceDate,
        exceptionalLocation: person.matrimonio?.datiMatrimonio?.luogoEvento?.luogoEccezionale || '',
        isDigital,
        digital: isDigital
          ? {
              documentDate: person.matrimonio?.datiMatrimonio?.attoEventoANPR?.attoANSC
                ?.dataFormazioneAtto
                ? DateTime.fromISO(
                    person.matrimonio?.datiMatrimonio?.attoEventoANPR?.attoANSC?.dataFormazioneAtto
                  )
                : null,
              idAnsc: person.matrimonio?.datiMatrimonio?.attoEventoANPR?.attoANSC?.idANSC || '',
              istatCode:
                person.matrimonio?.datiMatrimonio?.attoEventoANPR?.attoANSC?.comuneRegistrazione
                  ?.codiceIstat || '',
              municipality: {
                id:
                  person.matrimonio?.datiMatrimonio?.attoEventoANPR?.attoANSC?.comuneRegistrazione
                    ?.codiceIstat || '',
                description:
                  person.matrimonio?.datiMatrimonio?.attoEventoANPR?.attoANSC?.comuneRegistrazione
                    ?.nomeComune || '',
                province:
                  person.matrimonio?.datiMatrimonio?.attoEventoANPR?.attoANSC?.comuneRegistrazione
                    ?.siglaProvinciaIstat || '',
              },
              numberMunicipality:
                person.matrimonio?.datiMatrimonio?.attoEventoANPR?.attoANSC?.numeroComunale || '',
              year: person.matrimonio?.datiMatrimonio?.attoEventoANPR?.attoANSC?.anno || '',
              transcript:
                person.matrimonio?.datiMatrimonio?.attoEventoANPR?.attoANSC?.trascritto === '1'
                  ? true
                  : false,
            }
          : undefined,
        // paper
        municipality: person.matrimonio?.datiMatrimonio?.attoEventoANPR?.atto?.comuneRegistrazione
          ? {
              description:
                person.matrimonio?.datiMatrimonio?.attoEventoANPR?.atto?.comuneRegistrazione
                  ?.nomeComune || '',
              province:
                person.matrimonio?.datiMatrimonio?.attoEventoANPR?.atto?.comuneRegistrazione
                  ?.siglaProvinciaIstat || '',
              id:
                person.matrimonio?.datiMatrimonio?.attoEventoANPR?.atto?.comuneRegistrazione
                  ?.codiceIstat || '',
            }
          : undefined,
        year: person.matrimonio?.datiMatrimonio?.attoEventoANPR?.atto?.anno || '',
        province:
          person.matrimonio?.datiMatrimonio?.attoEventoANPR?.atto?.comuneRegistrazione
            ?.siglaProvinciaIstat || '',
        documentNumber: person.matrimonio?.datiMatrimonio?.attoEventoANPR?.atto?.numeroAtto || '',
        portion: person.matrimonio?.datiMatrimonio?.attoEventoANPR?.atto?.parte || '',
        range: person.matrimonio?.datiMatrimonio?.attoEventoANPR?.atto?.serie || '',
        regVol: person.matrimonio?.datiMatrimonio?.attoEventoANPR?.atto?.volume || '',
        office: person.matrimonio?.datiMatrimonio?.attoEventoANPR?.atto?.ufficioMunicipio || '',
        documentDate: person.matrimonio?.datiMatrimonio?.attoEventoANPR?.atto?.dataFormazioneAtto
          ? DateTime.fromISO(
              person.matrimonio?.datiMatrimonio?.attoEventoANPR?.atto?.dataFormazioneAtto
            )
          : null,
        transcript:
          person.matrimonio?.datiMatrimonio?.attoEventoANPR?.atto?.trascritto === '1'
            ? true
            : false,
      }
    : undefined;

  return originReturnData;
};
